// extracted by mini-css-extract-plugin
module.exports = {"main":"QuizGradebookTable_main__3t7I3","icon":"QuizGradebookTable_icon__7S56q"};